__turbopack_context__.v({
  "avatar-button": "styles-module__LO2GAq__avatar-button",
  "avatar-wrapper": "styles-module__LO2GAq__avatar-wrapper",
  "button-wrapper": "styles-module__LO2GAq__button-wrapper",
  "flipping-icon": "styles-module__LO2GAq__flipping-icon",
  "log-in-button": "styles-module__LO2GAq__log-in-button",
  "row-align-center": "styles-module__LO2GAq__row-align-center",
  "top-section-wrapper": "styles-module__LO2GAq__top-section-wrapper",
  "user-nav": "styles-module__LO2GAq__user-nav",
});
